// iOS (WKWebView) auto-zooms into a focused input whose font-size is < 16px, magnifying the whole
// page and pushing the rest of the form (e.g. the password field) off-screen behind the keyboard.
// A native app shell has no use for pinch-zoom, so lock the viewport scale on native to suppress the
// focus-zoom. Web is intentionally left untouched — browser zoom is an accessibility requirement there.
const LOCKED_VIEWPORT_CONTENT =
  'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, shrink-to-fit=no, viewport-fit=cover';

export const lockViewportZoom = () => {
  const viewportMeta = document.querySelector('meta[name="viewport"]');

  if (!viewportMeta) {
    return;
  }

  viewportMeta.setAttribute('content', LOCKED_VIEWPORT_CONTENT);
};
